import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import '../style.css'
import '../views/navigation.css'
import { getOpeningStatus } from '../utils/openingHours'
import { useAnnouncement } from '../context/AnnouncementContext'
import CartPanel from './CartPanel'
import HoursBadge from './HoursBadge'
export const DAY_KEYS = [
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
  'Dimanche'
]

export function getDayKey(date = new Date()) {
  const jsDay = date.getDay()
  return DAY_KEYS[(jsDay + 6) % 7]
}
const Navigation = ({ menu, showHoursTooltip, setShowHoursTooltip, toggleHoursTooltip }) => {

  const dayNames = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim']
  const { openingHours, onlineOrderHours } = menu || {}
  const location = useLocation()
  const isActive = (path) => location.pathname === path
  const dayKey = getDayKey(new Date())
  const hoursButtonRef = useRef(null)
  const [showHoursModal, setShowHoursModal] = useState(false)
  const { announcement, announcementActive, openDays, onlineOrderDays } = useAnnouncement()
  const {
    isOpen,
    isOnlineOrderOpen,
    label,
    detail
  } = getOpeningStatus(new Date(), {
    openDays,
    onlineOrderDays,
    openingHours,
    onlineOrderHours
  })

  useEffect(() => {
    const toggle = () => {
      setShowHoursTooltip(v => !v)
    }

    window.addEventListener('toggle-hours', toggle)

    return () => {
      window.removeEventListener('toggle-hours', toggle)
    }
  }, [])
  const getStatus = () => {
    if (announcementActive) {
      return 'closed-temp'
    }

    if (isOpen && isOnlineOrderOpen) {
      return 'open-full'
    }

    if (isOpen && !isOnlineOrderOpen) {
      return 'open-physical-only'
    }

    return 'closed'
  }
  const status = getStatus()

  const effectiveLabel =
    status === 'closed-temp'
      ? 'Fermée temporairement'
      : status === 'open-full'
        ? 'Ouvert • commande en ligne'
        : status === 'open-physical-only'
          ? 'Ouvert (sur place uniquement)'
          : 'Fermé'
  const tooltipRef = useRef(null)
  const normalizeTime = (v) => {
    if (v == null || v === '') return null
    return String(v).trim()
  }
  const groupDaysBySchedule = (days, openingHours) => {
    if (!days?.length || !openingHours) return []

    const map = new Map()

    for (const day of days) {
      if (!openingHours[day]) continue

      const h = openingHours[day]
      const open = normalizeTime(h.open) ?? '—'
      const close = normalizeTime(h.close) ?? '—'

      const key = `${open}__${close}`

      if (!map.has(key)) {
        map.set(key, { open, close, days: [day] })
      } else {
        map.get(key).days.push(day)
      }
    }

    return Array.from(map.values()).map(group => ({
      ...group,
      days: group.days.sort((a, b) => a - b)
    }))
  }
  const groupOnlineDaysBySchedule = (days, hoursMap) => {
    if (!days?.length || !hoursMap) return []

    const map = new Map()

    for (const day of days) {
      const h = hoursMap?.[day]
      if (!h?.lastOrder) continue

      const lastOrder = normalizeTime(h.lastOrder)

      const key = lastOrder

      if (!map.has(key)) {
        map.set(key, {
          lastOrder,
          days: [day],
        })
      } else {
        map.get(key).days.push(day)
      }
    }

    return Array.from(map.values()).map(group => ({
      ...group,
      days: group.days.sort((a, b) => a - b)
    }))
  }
  const compressDays = (days, names) => {
    if (!days?.length) return ''

    const sorted = [...days].sort((a, b) => a - b)

    const ranges = []
    let start = sorted[0]
    let prev = sorted[0]

    for (let i = 1; i < sorted.length; i++) {
      const d = sorted[i]

      if (d === prev + 1) {
        prev = d
        continue
      }

      ranges.push([start, prev])
      start = d
      prev = d
    }

    ranges.push([start, prev])

    return ranges
      .map(([s, e]) =>
        s === e ? names[s] : `${names[s]} - ${names[e]}`
      )
      .join(' - ')
  }

  const isOpenFull = status === 'open-full'
  const isOpenPhysicalOnly = status === 'open-physical-only'
  const isClosed = status === 'closed'
  const dotOpen = status !== 'closed' && status !== 'closed-temp'
  const groupedOpen = groupDaysBySchedule(
    openDays,
    openingHours
  )
  const groupedOnline = groupOnlineDaysBySchedule(
    Object.keys(onlineOrderHours || {}).map(Number),
    onlineOrderHours
  )
  const filteredOpen = groupedOpen.filter(group =>
    group.days.some(day => openDays.includes(day))
  );

  const filteredOnline = groupedOnline.filter(group =>
    group.days.some(day => onlineOrderDays.includes(day))
  )
  useEffect(() => {
    if (!showHoursTooltip) return
    const handleClickOutside = (e) => {
      if (
        tooltipRef.current && !tooltipRef.current.contains(e.target) &&
        hoursButtonRef.current && !hoursButtonRef.current.contains(e.target)
      ) {
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showHoursTooltip])
  console.log('openingHours', openingHours)
  console.log('openDays', openDays)
  console.log('groupedOpen', groupedOpen)
  return (
    <>
      <header className="nav-header">
        <div className="nav-bar">
          {/* Logo + blasons */}
          <Link to="/" className="nav-logo">
            <img
              src="/img/blason.webp"
              alt="Blason de Lalaing"
              className="nav-logo-crest"
            />

            <span className="nav-logo-text">
              <span className="nav-logo-main">Friterie</span>
              <span className="nav-logo-sub">de Lalaing</span>
            </span>

            <img
              src="/img/blason.webp"
              alt="Blason de Lalaing"
              className="nav-logo-crest"
            />
          </Link>

          {/* Liens de navigation centrés */}
          <nav className="nav-links" aria-label="Navigation principale">
            <Link
              to="/"
              className={isActive('/') ? 'nav-link active' : 'nav-link'}
            >
              Accueil
            </Link>
            <Link
              to="/menu"
              className={isActive('/menu') ? 'nav-link active' : 'nav-link'}
            >
              Menu
            </Link>
            <Link
              to="/patrimoine"
              className={
                isActive('/patrimoine') ? 'nav-link active' : 'nav-link'
              }
            >
              Patrimoine
            </Link>


          </nav>

          {/* Badge horaires */}
          <HoursBadge
            showHoursTooltip={showHoursTooltip}
            toggleHoursTooltip={toggleHoursTooltip}
            hoursButtonRef={hoursButtonRef}
            tooltipRef={tooltipRef}
            dotOpen={dotOpen}
            effectiveLabel={effectiveLabel}
            filteredOpen={filteredOpen}
            filteredOnline={filteredOnline}
            compressDays={compressDays}
            dayNames={dayNames}
          />
          {/* Lien admin discret (engrenage) */}
          <Link
            to="/admin"
            className="nav-admin-link"
            aria-label="Administration du menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>

          </Link>
        </div>

      </header>

    </>

  )

}

export default Navigation
